import {Component, inject} from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle
} from '@angular/material/dialog';
import {MatButton} from "@angular/material/button";


// Define the shape of the data passed to the dialog
export interface ConfirmDialogData {
    title?: string;
    message: string;
    info: string;
    details?: string[];
    confirmButtonText?: string;
    cancelButtonText?: string;
}

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    imports: [
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatButton
    ],
    styleUrls: ['./confirm-dialog.component.scss'] // Optional: Add styling as needed
})
export class ConfirmDialogComponent {
    dialogRef = inject<MatDialogRef<ConfirmDialogComponent>>(MatDialogRef);
    data = inject<ConfirmDialogData>(MAT_DIALOG_DATA);

    title: string;
    message: string;
    info: string;
    confirmButtonText: string | undefined;
    cancelButtonText: string | undefined;

    constructor() {
        const data = this.data;

        this.title = data.title || 'Confirm';
        this.message = data.message;
        this.info = data.info;
        this.confirmButtonText = data.confirmButtonText;
        this.cancelButtonText = data.cancelButtonText;
    }

    onConfirm(): void {
        // Close the dialog, return true
        this.dialogRef.close(true);
    }

    onDismiss(): void {
        // Close the dialog, return false
        this.dialogRef.close(false);
    }
}
